import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import languageModel from '../../../../models/language.model';
import loginModel from '../../../../models/login.model'
import { Dialog } from 'construct-ui';
import paginationComponent from '../../../../components/pagination/pagination.component';
import ViewBase from '../../../view-base.view';
import CVTrainingRequestRejectView from '../cvtrains/custom-vision.training-requests-reject.view';

export default function CVTrainingRequestsListView() {
    ViewBase.call(this);

    let currentCountry;

    let inputDataModel = { searchStatus: '001', totalCount: 0, pageIndex: 1, pageSize: 10 };
    
    let isPopupRejectTrainingRequestOpened = false;
    let selectedTrainingRequestId = 0;

    let list = [];
    
    let isAdmin = loginModel.credentials.admin;

    let _loadTrainingRequests = () => {
        this.showLoading();

        trainModel.getTrainingRequestsList(
            _trainingRequestsListSuccessCallback,
            _trainingRequestsListErrorCallback,
            inputDataModel.searchStatus, inputDataModel.pageIndex, inputDataModel.pageSize
        );
    }

    let _trainingRequestsListSuccessCallback = (result) => {
        this.hideLoading();
        
        list = result.data;
        if (list == null) {
            list = [];
        }
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
    }

    let _trainingRequestsListErrorCallback = (error) => {
        this.hideLoading();

        list = [];

        this.handleError(error);
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadTrainingRequests();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadTrainingRequests();
    }

    let _onRejectTrainingRequestComplete = () => {
        isPopupRejectTrainingRequestOpened = false;

        this.showMessage(this.getText("LT00000408", "The training request has been rejected."), this.getText("LT00000410", "Reject Training Request"));

        _loadTrainingRequests();
    }

    let _showApproveTrainingRequestConfirmation = (trainingRequestId) => {
        this.showConfirm(this.getText("LT00000409", "Are you sure you want to approve to train this project? A significant cost will be incurred."), this.getText("LT00000411", "Approve Training Request"), (e) => {

            if (e == "YES") {
                trainModel.approveTrainingRequest(
                    () => {
                        this.showMessage(this.getText("LT00000412", "The training request has been approved."), this.getText("LT00000411", "Approve Training Request"));

                        _loadTrainingRequests();
                    }, (error) => {
                        this.handleError(error);
                    },
                    trainingRequestId);
            }
        });

    }

    let _showRejectTrainingRequestConfirmation = (trainingRequestId) => {
        
        isPopupRejectTrainingRequestOpened = true;
        selectedTrainingRequestId = trainingRequestId;

    }

    return {
        oninit: (vnode) => {
            currentCountry = loginModel.credentials.country;

            _loadTrainingRequests();
        },
        onupdate: (vnode) => {
            if (loginModel.credentials.country !== currentCountry) {
                
                _loadTrainingRequests();
                currentCountry = loginModel.credentials.country;
            }
        },    
        view: (vnode) => {
            
            return [
                m('.row',
                    m('.col-md-12',
                        m('.card',
                            m('.card-body',
                                m(".table-responsive",
                                    m("table.table table-striped",
                                        [
                                            m("thead",
                                                m("tr.align-middle",
                                                    [
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000413", "S/N")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000414", "Project")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000415", "Submitted By")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000416", "Submitted At")),
                                                        m("th", { "scope": "col" }, languageModel.getText("LT00000417", "Last Approved At")),
                                                        isAdmin && m("th", { "scope": "col", "colspan": "2" }, "")
                                                    ])
                                            ),
                                            m("tbody",
                                                list.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": isAdmin ? "7" : "5" }, languageModel.getText("EM00000141", "No records found."))
                                                ),
                                                list.map((trainingRequest, index) =>
                                                    [
                                                        m("tr",
                                                            [
                                                                m("td", index + 1),
                                                                m("td", trainingRequest.projectName),
                                                                m("td", trainingRequest.createUserName),
                                                                m("td", trainingRequest.createDateDisplay),
                                                                m("td", [m('div', trainingRequest.lastApprovedDateDisplay), m('.text-secondary', trainingRequest.lastApprovedDateExplanation)]),
                                                                isAdmin && m("td", m("a", { "href": "javascript:;", onclick: () => { _showApproveTrainingRequestConfirmation(trainingRequest.id) } }, m("span", languageModel.getText("LT00000185", "Approve")))),
                                                                isAdmin && m("td", m("a.text-danger", { "href": "javascript:;", onclick: () => { _showRejectTrainingRequestConfirmation(trainingRequest.id) } }, m("span", languageModel.getText("LT00000184", "Reject"))))
                                                            ])
                                                    ]),
                                            )
                                        ]
                                    )
                                ),
                                m(paginationComponent,
                                    {
                                        currentPage: inputDataModel.pageIndex,
                                        pageSize: inputDataModel.pageSize,
                                        totalItems: inputDataModel.totalCount,
                                        onPageChanged: onPageChanged,
                                        onPageSizeChanged: onPageSizeChanged
                                    }
                                )
                            )
                        )
                    ),
                ),
                m(Dialog, {
                    isOpen: isPopupRejectTrainingRequestOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupRejectTrainingRequestOpened = false; },
                    title: this.getText("LT00000410", "Reject Training Request"),
                    content: m(CVTrainingRequestRejectView, { 
                        trainingRequestId: selectedTrainingRequestId,
                        onPopupClose: ()=>{ isPopupRejectTrainingRequestOpened = false; },
                        onSaveComplete: _onRejectTrainingRequestComplete
                    }),
                    "class": "cui-dialog-xxl"
                }),
                this.getBaseViews()
            ]
        }
    }
}
